// The grunnlag written to audit_log for an oppslag i pasientjournal. One list,
// so the anamnese pages offer the same wording everywhere.
export const IMPERSONATION_REASONS = {
  requisition: "Behandle rekvirering",
  snailMailRequisition: "Bekrefte snail-mail rekvirering",
  requisitionedCustomer: "Se rekvirert kunde",
  suggestBiomarkers: "Foreslå biomarkører for blodprøve",
  writeAssessment: "Skrive analyse og anbefaling",
  answerPatientMessage: "Svare på melding fra pasient",
  approvedAssessment: "Se godkjent analyse",
  technicalIssue: "Undersøke teknisk problem",
} as const;

export const COMMON_IMPERSONATION_REASONS = [
  IMPERSONATION_REASONS.suggestBiomarkers,
  IMPERSONATION_REASONS.writeAssessment,
  IMPERSONATION_REASONS.answerPatientMessage,
  IMPERSONATION_REASONS.technicalIssue,
] as const;
